import Bugsnag from "@bugsnag/js";
import axiosInstance from "../../axiosInstance";
import URL from "../../urls";
import {
  SET_AI_CHAT_FEATURE_FLAG,
  SET_AI_ENABLED_FEATURE_FLAG,
  SET_AI_INTAKE_REPORT_FEATURE_FLAG,
  SET_AI_OFFLINE_RECORDING_FEATURE_FLAG,
  SET_FEATURE_FLAGS,
  SET_TWA_MASTER_AI_CONSENT_FEATURE_FLAG,
  SET_AI_CHAT_FEATURE_FLAG_VERSION,
} from "./types";

export const setFeatureFlags = features => ({
  type: SET_FEATURE_FLAGS,
  payload: features,
});

export const getAIFeatureFlag = () => {
  return async dispatch => {
    try {
      const { data = {} } = await axiosInstance.get(URL.aiFeatureFlag);
      const {
        ai_chat_feature,
        master_ai_consent,
        twa_master_ai_consent,
        ai_enabled,
        is_ai_consent_touched,
        is_ai_report_enabled,
        is_offline_recording_enabled,
        ai_chat_feature_version,
      } = data?.data || data || {};

      dispatch({
        type: SET_AI_CHAT_FEATURE_FLAG,
        payload: !!ai_chat_feature,
      });

      dispatch({
        type: SET_TWA_MASTER_AI_CONSENT_FEATURE_FLAG,
        payload: !!twa_master_ai_consent,
      });

      dispatch({
        type: SET_AI_ENABLED_FEATURE_FLAG,
        payload: !!(
          (master_ai_consent || twa_master_ai_consent) &&
          (is_ai_consent_touched || ai_enabled)
        ),
      });

      dispatch({
        type: SET_AI_INTAKE_REPORT_FEATURE_FLAG,
        payload: !!is_ai_report_enabled,
      });

      dispatch({
        type: SET_AI_OFFLINE_RECORDING_FEATURE_FLAG,
        payload: !!is_offline_recording_enabled,
      });
      dispatch({
        type: SET_AI_CHAT_FEATURE_FLAG_VERSION,
        payload: ai_chat_feature_version || "v2",
      });
    } catch (error) {
      if (error?.message === "canceled") return; // required for cancelled requests
      Bugsnag.notify(error);
    }
  };
};
